module.exports = __webpack_public_path__ + "img/sample-voronoi-high.2cf58566.png";